import React from 'react';
import {connect} from "react-redux";
import {addRating} from "../../actions/updateFirestoreData/recipesData/addRating";
import {Grid, Slider, Typography, Button} from "@material-ui/core";
import {RateIcon} from "../mui/RateIcon";


/**
 * This class will allowed to rate a recipe (0 to 5 stars), this thanks to a slider
 */
class RateSlider extends React.Component {
    state = {
        ratingValue: 2.5,
    };

    valuetext = (value) => {
        if (value !== this.state.ratingValue) {
            this.setState({ratingValue: value});
        }
        return `${value}`;
    };

    validRating = async () => {
        const auth = this.props.auth;
        let {recipeName} = this.props;
        await this.props.addRating({
            userPseudo: auth.pseudo,
            recipeName: recipeName,
            rating: this.state.ratingValue
        });
    };


    render() {
        return (
            <div style={{marginTop: 10}}>
                <Typography style={{textAlign: 'center'}} id="discrete-slider" gutterBottom>Note</Typography>

                <Slider
                    defaultValue={2.5} getAriaValueText={this.valuetext}
                    aria-labelledby="discrete-slider"
                    step={0.5} marks min={0} max={5}/>

                <RateIcon rateValue={this.state.ratingValue}/>

                <Grid item xs={12}>
                    <Grid container justify='center' style={{marginTop: 5}}>
                        <Button type="submit" variant="contained" color="primary" onClick={this.validRating}>
                            Valider
                        </Button>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = ({auth}) => {
    return {auth}
};


export default connect(
    mapStateToProps,
    {addRating}
)(RateSlider)
